export function isNullOrUndefined(obj: any) {
    return obj === undefined || obj === null;
}